/* Contact form.
   Posts #ContactForm to Shopify's /contact endpoint (Shopify emails the store's
   Sender email) with a full-page fallback for Shopify's bot challenge.
   The HubSpot tracker's form collector records submissions on its own. */
(function (root) {
  'use strict';

  // Maps the form's raw input values to the contact[...] keys Shopify's
  // /contact endpoint expects. Empty values are left out so the email only
  // lists what the visitor filled in.
  function buildContactParams(values) {
    var params = new URLSearchParams();
    params.append('form_type', 'contact');
    params.append('utf8', '✓');
    var mapping = [
      ['email', 'contact[email]'],
      ['firstname', 'contact[First name]'],
      ['lastname', 'contact[Last name]'],
      ['company', 'contact[Company]'],
      ['phone', 'contact[Phone]'],
      ['linkedin', 'contact[LinkedIn]'],
      ['message', 'contact[body]'],
      ['sourcePage', 'contact[Source page]']
    ];
    for (var i = 0; i < mapping.length; i++) {
      var value = values[mapping[i][0]];
      if (value === undefined || value === null) continue;
      value = String(value).trim();
      if (value === '') continue;
      params.append(mapping[i][1], value);
    }
    return params;
  }

  // Shopify redirects a successful /contact POST back to the referring page
  // with ?contact_posted=true. The /challenge page and a re-rendered error
  // page never carry it.
  function isPostedUrl(url) {
    if (!url) return false;
    var parsed;
    try {
      parsed = new URL(url, 'https://placeholder.invalid');
    } catch (e) {
      return false;
    }
    return parsed.searchParams.get('contact_posted') === 'true';
  }

  // The section renders #ContactForm-Status with this class only when
  // form.posted_successfully? is true.
  function hasPostedMarkup(html) {
    return typeof html === 'string' && html.indexOf('contact-status--success') !== -1;
  }

  // ...and with this class only when Shopify re-rendered the page with
  // form.errors (e.g. an email address Shopify rejects).
  function hasErrorMarkup(html) {
    return typeof html === 'string' && html.indexOf('contact-status--error') !== -1;
  }

  // Pulls the message out of a server-rendered status box so the inline
  // error can say what Shopify said ("Email is invalid") instead of the
  // generic text. Returns null when the markup is not there.
  function extractStatusText(html) {
    if (typeof html !== 'string') return null;
    var match = html.match(/<span class="contact-status__text">([\s\S]*?)<\/span>/);
    if (!match) return null;
    var text = match[1]
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
    return text === '' ? null : text;
  }

  var helpers = {
    buildContactParams: buildContactParams,
    isPostedUrl: isPostedUrl,
    hasPostedMarkup: hasPostedMarkup,
    hasErrorMarkup: hasErrorMarkup,
    extractStatusText: extractStatusText
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = helpers;
  root.SiteContactForm = helpers;

  if (typeof document === 'undefined') return;
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('ContactForm');
    if (!form) return;

    var statusEl = document.getElementById('ContactForm-Status');
    var submitBtn = form.querySelector('button[type="submit"]');
    var btnLabel = submitBtn ? submitBtn.querySelector('.contact-button__label') : null;

    var SUCCESS_MSG = (statusEl && statusEl.getAttribute('data-success-message')) || 'Thanks — we got your message.';
    var ERROR_MSG = (statusEl && statusEl.getAttribute('data-error-message')) || 'Something went wrong. Please try again.';
    var SUBMITTING_TEXT = (statusEl && statusEl.getAttribute('data-submitting-text')) || 'Sending...';
    var DEFAULT_BTN_TEXT = (submitBtn && submitBtn.getAttribute('data-default-text')) || (btnLabel && btnLabel.textContent) || 'Send message';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      // Honeypot: bots fill the hidden field. Pretend it worked, send nothing.
      var honeypot = document.getElementById('ContactForm-Website');
      if (honeypot && honeypot.value) {
        showSuccess();
        form.reset();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var params = buildContactParams({
        firstname: getValue('ContactForm-FirstName'),
        lastname: getValue('ContactForm-LastName'),
        email: getValue('ContactForm-email'),
        company: getValue('ContactForm-CompanyName'),
        phone: getValue('ContactForm-Phone'),
        linkedin: getValue('ContactForm-LinkedIn'),
        message: getValue('ContactForm-body'),
        sourcePage: getValue('ContactForm-SourcePage')
      });

      setLoading(true);
      clearStatus();

      fetch(form.action, {
        method: 'POST',
        body: params,
        credentials: 'same-origin',
        redirect: 'follow',
        referrer: window.location.href
      })
        .then(function (res) {
          if (isPostedUrl(res.url)) {
            succeed();
            return;
          }
          return res.text().then(function (html) {
            if (hasPostedMarkup(html)) {
              succeed();
              return;
            }
            if (hasErrorMarkup(html)) {
              // Shopify re-rendered the page with a validation error. Show it
              // inline and keep what the visitor typed.
              renderStatus('error', extractStatusText(html) || ERROR_MSG);
              setLoading(false);
              return;
            }
            // Shopify answered with its bot challenge page or something else
            // we cannot complete from here. Only a real navigation can.
            submitNatively(params);
          });
        })
        .catch(function (err) {
          console.error('Contact form: network error', err);
          showError();
          setLoading(false);
        });
    });

    function succeed() {
      showSuccess();
      form.reset();
      setLoading(false);
    }

    // Re-posts the same data as a normal form submission. form.submit() fires
    // no submit event, so this handler and the HubSpot collector do not run a
    // second time; the browser lands on Shopify's challenge page or back on
    // this page with the server-rendered status.
    function submitNatively(params) {
      params.forEach(function (value, key) {
        if (key === 'form_type' || key === 'utf8') return; // rendered by {% form %}
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });
      form.submit();
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      if (btnLabel) {
        btnLabel.textContent = isLoading ? SUBMITTING_TEXT : DEFAULT_BTN_TEXT;
      }
    }

    function showSuccess() {
      renderStatus('success', SUCCESS_MSG);
    }

    function showError() {
      renderStatus('error', ERROR_MSG);
    }

    function clearStatus() {
      if (!statusEl) return;
      statusEl.hidden = true;
      statusEl.className = 'contact-status';
      statusEl.textContent = '';
    }

    function renderStatus(kind, message) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.className = 'contact-status contact-status--' + kind;
      statusEl.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      statusEl.textContent = '';

      var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.setAttribute('class', 'contact-status__icon');
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('width', '20');
      icon.setAttribute('height', '20');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('fill', 'currentColor');
      if (kind === 'success') {
        path.setAttribute('d', 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z');
      } else {
        path.setAttribute('d', 'M12 2 1 21h22zM13 18h-2v-2h2zm0-4h-2V9h2z');
      }
      icon.appendChild(path);

      var text = document.createElement('span');
      text.className = 'contact-status__text';
      text.textContent = message;

      statusEl.appendChild(icon);
      statusEl.appendChild(text);

      if (typeof statusEl.scrollIntoView === 'function') {
        statusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function getValue(id) {
      var el = document.getElementById(id);
      return el ? el.value : undefined;
    }
  });
})(typeof window !== 'undefined' ? window : globalThis);
